import { render, staticRenderFns } from "./tipoDocumentoLegal.vue?vue&type=template&id=690c5a82"
import script from "./tipoDocumentoLegal.vue?vue&type=script&lang=js"
export * from "./tipoDocumentoLegal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports